import React from 'react';

import { useFormSubmit } from '@occc-app/hooks/useFormSubmit';

import { createSegmentFormId } from './SegmentCreateFormContainer';
import SegmentCreate from './SegmentCreate';

const SegmentCreateContainer: React.FC = () => {
  const submitCreateSegmentForm = useFormSubmit(createSegmentFormId);

  return <SegmentCreate submitCreateSegmentForm={submitCreateSegmentForm} />;
};

export default SegmentCreateContainer;
